module.exports = __webpack_public_path__ + "images/19743-INT2-789029a27bcaf3d2e89fabb3af8dfea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/19743-INT2.jpg
// module id = 752
// module chunks = 0